module.exports = __webpack_public_path__ + "static/img/training_system_s4_max3.8bb7e14f.png";